import React, {Component, Fragment} from 'react'
import {Row, Col, Button} from 'antd'
import {Sparklines, SparklinesLine, SparklinesReferenceLine} from 'react-sparklines'
import { get } from 'axios'
import {StyledLogHeader, StyleSpan} from './style'

class LoggedInHeader extends Component {

  state = {
    marketList: [],
    isMarketOpen: null,
  }

  componentDidMount() {
    this.getTableSource()
  }

  getTableSource = () => {
    Promise.all([
      get(`https://cloud.iexapis.com/v1/stock/SPY/quote?token=pk_ff59a3b39cf04827aed30a4797e5a6f0`),
      get(`https://cloud.iexapis.com/v1/stock/IWM/quote?token=pk_ff59a3b39cf04827aed30a4797e5a6f0`),
      get(`https://cloud.iexapis.com/v1/stock/DIA/quote?token=pk_ff59a3b39cf04827aed30a4797e5a6f0`),
      get(`https://cloud.iexapis.com/v1/stock/SPY/chart/1d?changeFromClose=true&token=pk_ff59a3b39cf04827aed30a4797e5a6f0`),
      get(`https://cloud.iexapis.com/v1/stock/IWM/chart/1d?changeFromClose=true&token=pk_ff59a3b39cf04827aed30a4797e5a6f0`),
      get(`https://cloud.iexapis.com/v1/stock/DIA/chart/1d?changeFromClose=true&token=pk_ff59a3b39cf04827aed30a4797e5a6f0`),
    ]).then((values) => {
      const SPY = { name: 'SPY',
        text: 'S&P 500', chartData: [],};
      const IWM = {
        name: 'IWM',
        text: 'Russell 2000',
        chartData: [],
      };
      const DIA = {
        name: 'DIA',
        text: 'Dow 30',
        chartData: [],
      };
      values.slice(0,3).forEach((market) => {
        if (market.data.symbol === 'SPY') {
          SPY.changePercent = market.data.changePercent;
        } else if (market.data.symbol === 'IWM') {
          IWM.changePercent = market.data.changePercent;
        } else if (market.data.symbol === 'DIA') {
          DIA.changePercent = market.data.changePercent;
        }
      });
      values.slice(3,7).forEach((market, index) => {
        let data = 0;
        if (market.data) {
          data = market.data.map(x=>x.changeOverTime).filter(x=>x);
        }
        if (index === 0) {
          SPY.chartData = data;
        } else if (index === 1) {
          IWM.chartData = data;
        } else if (index === 2) {
          DIA.chartData = data;
        }
      })
      this.setState({
        marketList: [SPY, IWM, DIA]
      })
    });
    get('https://cloud.iexapis.com/v1/deep/system-event?token=pk_ff59a3b39cf04827aed30a4797e5a6f0').then(res=>{
      if(res && res.data) {
        this.setState({
          isMarketOpen: res.data.systemEvent === 'R'
        })
      }
    })
  }

  render() {
    const { marketList, isMarketOpen } = this.state;
    return (
      <Fragment>
      <StyleSpan className={`${isMarketOpen ? 'open' : 'closed'}`}>
        {isMarketOpen !== null && <Button>Market is {isMarketOpen ? 'open' : 'closed'}</Button>}
      </StyleSpan>
      <StyledLogHeader>
        <Row>
          {
            marketList.map(market => (
              <Col key={market.name} span={8}>
                <h6>
                  {market.text}<br/>
                  <small className={`${market.changePercent > 0 ? 'positive' : 'negative'} ${market.changePercent === 0 && 'black'}`}>{((market.changePercent || 0) * 100).toFixed(3) }%</small>
                </h6>
                <Sparklines svgWidth={80} svgHeight={50} data={market.chartData}>
                  <SparklinesLine style={{ fill: "none" }} />
                  <SparklinesReferenceLine />
                </Sparklines>
              </Col>
            ))
          }
        </Row>
      </StyledLogHeader>
      </Fragment>
    )
  }
}

export default LoggedInHeader


// WEBPACK FOOTER //
// ./src/components/layout-main/LoggedInHeader.js